<template>
  <b-modal :id="modalId" :title="title" hide-footer no-close-on-backdrop>
    <b-tabs content-class="mt-3" v-if="selectedGroup">
      <b-tab title="Profile" active>
        <div class="tab-box">
          <profile-row heading="NAME" :info="selectedGroup.name" />
          <profile-row heading="DESCRIPTION" v-if="selectedGroup.description" :info="selectedGroup.description" />
          <profile-row heading="ACTIVATION" v-if="canEditGroup && canActivateGroup">
            <template v-slot:info-slot>
              <activation-toggle :activationStatus="selectedGroup.is_active"
                :isLoading="isTogglingActivation"
                @toggleActivation="toggleActivation" />
            </template>
          </profile-row>
        </div>
      </b-tab>
      <b-tab title="Edit" v-if="canEditGroup">
        <edit-group-form :group="selectedGroup" @hasUpdate="organizationUpdate" />
      </b-tab>
      <b-tab title="Add Group" v-if="canEditGroup">
        <new-group-form :parent="selectedGroup" @hasUpdate="hasUpdate" />
      </b-tab>
      <slot v-if="canEditGroup" name="isEditable"></slot>
      <slot></slot>
    </b-tabs>
  </b-modal>
</template>

<script>
import EditGroupForm from '../Forms/EditGroupForm.vue';
import NewGroupForm from '../Forms/NewGroupForm.vue';
import ProfileRow from '../ProfileRow.vue';
import ActivationToggle from '../Inputs/ActivationToggle.vue';
import config from '../../constants/config';
import { mapGetters } from 'vuex';

export default {
  name: 'GroupModal',
  components: {
    EditGroupForm,
    NewGroupForm,
    ProfileRow,
    ActivationToggle
  },
  data() {
    return {
      isTogglingActivation: false
    }
  },
  methods: {
    async toggleActivation() {
      this.isTogglingActivation = true;
      const success = await this.$store.dispatch('group/toggleActivation', this.selectedGroup);
      if (success) {
        this.hasUpdate();
      }
      this.isTogglingActivation = false;
    },
    hasUpdate() {
      this.$emit('hasUpdate');
    },
    organizationUpdate() {
      this.$emit('hasUpdate');

      // update organizations
      if ((this.isSuperUser || this.isStaffUser) && this.selectedGroup.id == this.topLevelGroup.id) {
        this.$store.dispatch('organization/refetchOrganizations');
      }
    }
  },
  computed: {
    ...mapGetters('group', ['selectedGroup', 'topLevelGroup']),
    ...mapGetters('user', ['isMember', 'isManager', 'isSuperUser', 'isStaffUser', 'user']),
    modalId() {
      return config.GROUP_MODAL_ID;
    },
    title() {
      return this.selectedGroup ? this.selectedGroup.name : "";
    },
    canEditGroup() {
      return !this.isMember;
    },
    canActivateGroup() {
      if (!this.selectedGroup || !this.user || !this.user.group) {
        return false;
      }
      return this.selectedGroup.id != this.user.group.id;
    }
  }
};
</script>
